const balloonBlock = `<h2>Taj Mahal: A breathtaking ode to love</h2>

\t<figure class="image image-style-side" height="400">
\t\t<img src="https://www.makemytrip.com/travel-guide/media/dg_image/agra/1_Taj_Mahal.jpg">
\t\t<figcaption>Taj Mahal with its poetic white marble tomb</figcaption>
\t</figure>

\t<p>No trip to India is complete without visiting this spectacular monument, <a href="https://en.wikipedia.org/wiki/New7Wonders_of_the_World"><strong>counted among the Seven Wonders of the World</strong></a>.
\t</p>

\t<p>Tourists frequently admit that Taj Mahal "simply cannot be described with words". And that’s probably true. The more you try the more speechless you become. Words give only a semblance of truth. The real truth about its beauty is revealed when you adore <strong>different shades of “Taj” depending on the time of the day</strong> or when you admire the exquisite inlay work in different corners of the façade.</p>

\t<h3>Masterpiece of the world’s heritage</h3>

\t<p>Taj Mahal is a mausoleum built in Agra between 1631 and 1648 by Emperor Shah Jahan <strong>in the memory of his beloved wife</strong>, Mumtaz Mahal, whose body lies there. It took 20 000 workers to complete and the excellence of this building is visible in every brick.</p>

\t<p>In 1983, Taj Mahal was appointed <a href="https://en.wikipedia.org/wiki/World_Heritage_Site">UNESCO World Heritage Site</a> for being "the jewel of Muslim art in India and one of the universally admired masterpieces of the world's heritage".</p>

\t<p>If you like having a methodology for visiting historical places, here are the four elements on which we recommend to focus your attention:</p>

\t<ul>
\t\t<li>The tomb</li>
\t\t<li>The Decorations</li>
\t\t<li>The Garden</li>
\t\t<li>The Outlying buildings</li>
\t</ul>

\t<p>The tomb is what immediately catches your eyesight. The <strong>white and soft marble</strong> embroidered with stones leaves you totally enchanted.</p>
`;
export default balloonBlock;
